export const ADD_DECK_TO_CART = 'ADD_DECK_TO_CART';
export const REMOVE_DECK_FROM_CART = 'REMOVE_DECK_FROM_CART';
export const ADD_ALL_DECKS_TO_CART = 'ADD_ALL_DECKS_TO_CART';
